"use client";
import React, { useRef, useState } from "react";
import Slider, { Settings } from "react-slick";
import BTCDominanceSlide from "./BTCDominanceSlide";
import FearGreedSlide from "./FearGreedSlide";
import LiquidationSlide, { LiquidityDuration } from "./LiquidationSlide";
import NavigationButtons from "./NavigationButtons";

// Custom paging dot
const customPaging = (i: number, activeSlide: number) => (
  <div className={`h-[6px] w-full rounded-md mx-1 ${i === activeSlide ? "bg-primary" : "bg-gray-200"}`} />
);

const FearAndGreedIndex: React.FC = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [activeTimeframe, setActiveTimeframe] = useState<LiquidityDuration>("1H");
  const sliderRef = useRef<Slider>(null);

  const sliderSettings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    className: "fear-and-greed-slider",
    beforeChange: (_: number, next: number) => setActiveSlide(next),
    appendDots: (dots: React.ReactNode[]) => {
      const maxDots = 12;
      const limitedDots = React.Children.toArray(dots).slice(0, maxDots);

      return (
        <div className="flex items-center justify-center mt-2">
          <ul className="flex gap-1 m-0 p-0 max-w-[100px]">{dots.length <= maxDots ? dots : limitedDots}</ul>
        </div>
      );
    },
    customPaging: (i: number) => customPaging(i, activeSlide),
  };

  const SlideWrapper = ({ children }: { children: React.ReactNode }) => (
    <div className="slide-wrapper">
      <div className="slide-content">{children}</div>
    </div>
  );

  return (
    <div className="relative">
      <FearGreedSlide />
      {/* <div className="w-[calc(100%+40px)] flex justify-between absolute bottom-1/2 right-1/2 translate-x-1/2 translate-y-1/2 z-10">
        <NavigationButtons
          onPrev={() => sliderRef.current?.slickPrev()}
          onNext={() => sliderRef.current?.slickNext()}
        />
      </div> */}
    </div>
  );
};

export default React.memo(FearAndGreedIndex);
